<header #header class="Header">
  <div class="Header-wp">
    <a [routerLink]="HtmlRoutePages.home | localize" class="Header-logo">
      <img [src]="getAssetUrl('assets/logo.png')" alt="" />
      <span class="spanPadding">
        <b *isSelectedSite>Selected</b>
        <b *isUKSite>Used Truck Centres</b>
        <b *isTXSite>Trade & Export Trucks</b>

        <span *isSelectedSite class="Header-logo-ukSpan">Used Trucks</span>
        <span *isUKSite class="Header-logo-ukSpan">United Kingdom</span>
        <span *isTXSite class="Header-logo-ukSpan">UK & Worldwide</span>
      </span>
    </a>

    <div *ngIf="navLinks" class="Header-nav">
      <nav mat-tab-nav-bar color="warn">
        <a mat-tab-link *ngFor="let link of navLinks" href="{{link.path | localize}}"
          [routerLink]="link.path | localize " [active]="rla.isActive" routerLinkActive #rla="routerLinkActive"
          class="Header-navLink" data-cy="header-navlinks"
          [ngClass]="this.region===regionEnum.TX?'Header-navLink-txnavlink':''">
          {{ link.label | lowercase | translate }}
        </a>
      </nav>
    </div>
    <div class="Header-rightBox">

      <!-- <button class="header__wrapper__right__login-button" *ngIf="!isLoggedIn() && !environment.production" href="#"
        (click)="loginAndNavigate($event)">Login
      </button> -->
      <div class="header__wrapper__right__user-profile" *ngIf="isLoggedIn() && !environment.production"
        (click)="toggleDropdown($event)">
        <div class="header__wrapper__right__avater">{{ userInitials }}</div>
        <div class="header__wrapper__right__dropdown-icon">
          <img [src]="getAssetUrl('assets/icons/ChevronDown.svg')" alt="ChevronDown Icon" width="20" height="20"
               [ngClass]="{'rotate-180': dropdownOpen}" />
        </div>
        <div *ngIf="dropdownOpen" class="header__wrapper__right__dropdown-overlay" (click)="closeDropdown($event)">
          <div class="header__wrapper__right__dropdown-menu" (click)="$event.stopPropagation()">
            <app-internal-filter [selectedCountries]="selectedCountries$ | async" [isHeaderMode]=true
              (click)="closeDropdown($event)"></app-internal-filter>
          </div>
        </div>
      </div>

      <volvo-language-select *isSelectedSite></volvo-language-select>
      <div class="Header-mobBtns">
        <button (click)="onMenuClick()" class="BtnIcon" mat-button data-cy="btn-menu">
          <img class="menuDimension" [src]="assetService.getAssetUrl('assets/pages/home/MenuHamburger.jpg')"
            alt="Menu" />
        </button>
      </div>
    </div>
  </div>
  <volvo-sub-header [subHeader]="activeSubheader" (scrollTo)="scrollToElement($event)" *ngIf="activeSubheader">
  </volvo-sub-header>
</header>